export default "__VITE_ASSET__CVpmfuRe__"